'use client';

import type { ReactElement } from 'react';
import { chain } from '@/lib/constants';
import { useScopedI18n } from '@/locales/client';

export default function Based(): ReactElement {
  const t = useScopedI18n('footer');
  return (
    <div className="w-fit flex items-center justify-center gap-1.5">
      <p className="font-light text-sm opacity-90">{t('based')}</p>
      <p className="w-fit opacity-90 cursor-pointer hover:opacity-100 transition-all flex flex-row items-center justify-center gap-1 font-bold text-base">
        {chain.name}
      </p>
    </div>
  );
}
